/**
 * Pilot onboarding stages - canonical copy used in /me Hosting tile and admin queue.
 *
 * NO EM DASHES. Approved punctuation: period, comma, bullet, colon, slash.
 * 
 * Stage resolution (server-side):
 *   - invited            : portal_invite exists, no claim, no intake
 *   - submitted          : intake submitted, dashboard_status='pending_review'
 *   - awaiting_activation: admin linked org but dashboard_status still 'pending_review'
 *   - active             : dashboard_status='active'  (renders the actual tile)
 *   - paused             : dashboard_status='paused'
 *   - archived           : dashboard_status='archived' (hidden from /me)
 */

export const PILOT_STAGE_COPY = {
  invited: {
    label: "Invitation pending",
    body: "Invitation pending. Finish signup to activate.",
    cta_label: "Finish signup",
    cta_to: (e) => e.invite_token ? `/portal/invite/${e.invite_token}` : "/me",
    badge_color: "#F59E0B",  // amber
    is_clickable: true,
  },
  submitted: {
    label: "Intake complete",
    body: "Intake complete. Admin is reviewing your dashboard.",
    cta_label: "View summary",
    cta_to: (e) => `/me?summary=${e.event_id}`,
    badge_color: "#3B82F6",  // blue
    is_clickable: false,
  },
  awaiting_activation: {
    label: "Activating",
    body: "Dashboard ready. Activating soon.",
    cta_label: "View summary",
    cta_to: (e) => `/me?summary=${e.event_id}`,
    badge_color: "#8B5CF6",  // purple
    is_clickable: false,
  },
  active: {
    label: "Active",
    body: null, // no banner copy, the tile itself is interactive
    cta_label: "Open dashboard",
    cta_to: (e) => `/host/v2/${e.event_id}`,
    badge_color: "#10B981",  // emerald
    is_clickable: true,
  },
  paused: {
    label: "Paused",
    body: "On pause. Contact admin.",
    cta_label: null,
    cta_to: () => "/me",
    badge_color: "#6B7280",  // gray
    is_clickable: false,
  },
};

export function getPilotStage(event) {
  if (!event) return null;
  const ds = event.dashboard_status || "active";
  if (ds === "active") return "active";
  if (ds === "paused") return "paused";
  if (ds === "archived") return null; // hidden
  // pending_review fallback: look at flags from server
  if (event.pilot_stage) return event.pilot_stage;
  return "submitted";
}

export default PILOT_STAGE_COPY;
